<template>
  <div class="pad">
    <b-row :class="'pidkey_' + product.pidkey"
      ><!-- per identificare chiaramente pad/prodotto -->
      <b-col class="pad__column pad__column--first" cols="12" lg="3">
        <div
          class="pad__image"
          :style="{
            'background-image': `${statics.urlThumbProdotto ? `url(${statics.urlThumbProdotto})` : ''}, url('/assets/images/common/statics/room_placeholder.png')`,
          }"
        >
          <span class="pad__image-corner"></span>
        </div>
      </b-col>
      <b-col class="pad__column pad__column--second" cols="12" lg="9">
        <div class="pad__wrap">
          <b-row class="pad__row">
            <b-col
              class="pad__wrap-element pad__wrap-column--first"
              cols="12"
              lg="8"
              xl="9"
            >
              <div class="pad__head">
                <div class="pad__head-title">
                  <div
                    class="pad__head-star"
                    v-if="contains_numb(product.rating)"
                  >
                    <b-form-rating
                      no-border
                      inline
                      readonly
                      size="sm"
                      :value="product.rating.match(/\d+/)[0]"
                    />
                  </div>

                  <h2 class="pad__head-name">{{ statics.nomeProdotto }}</h2>
                  <img
                    class="pad__head-brand"
                    :src="'assets/images/alpitour/liveat-brands/' + brand.logo"
                    :alt="brand.name"
                  />
                </div>
                <p class="pad__head-locality">
                  {{ statics.city | capitalize }}
                </p>
                <p
                  class="pad__head-abstract"
                  v-html="statics.abstractProdotto"
                ></p>
              </div>
              <div class="pad__push">
                <vb-icon
                  class="pad__push-btn"
                  v-b-popover.hover.top.html="
                    '<span class=\'text-capitalize\'>' +
                    product.room.toLowerCase() +
                    '</span>'
                  "
                  :name="'doublebed'"
                  :color="sass('dark')"
                  :size="16"
                />
                <vb-icon
                  class="pad__push-btn"
                  v-b-popover.hover.top.html="
                    '<span class=\'text-capitalize\'>' +
                    product.accommodation.toLowerCase() +
                    '</span>'
                  "
                  :name="'cutlery'"
                  :color="sass('dark')"
                  :size="16"
                />
                <!-- Per ora l'assicurazione è da nascondere -->
                <!--<vb-icon class="pad__push-btn" v-b-popover.hover.top="'Assicurazione'" :name="'shield'" :color="sass('dark')" :size="16" />-->
              </div>
              <div class="pad__info">
                <div
                  v-if="product.departureAirportDescription"
                  class="pad__info-item"
                >
                  <vb-icon
                    class="pad__info-icon"
                    :name="'air_start'"
                    :color="sass('primary')"
                    :size="15"
                  />
                  <span class="pad__info-title">
                    da
                    {{ product.departureAirportDescription | capitalize }}
                    {{ product.departureAirportCode }}
                  </span>
                </div>
                <div class="pad__info-item">
                  <vb-icon
                    class="pad__info-icon"
                    :name="'calendar'"
                    :color="sass('primary')"
                    :size="15"
                  />
                  <span class="pad__info-title">
                    {{ parse_date(product.departureDate).day_number }}
                    {{
                      parse_date(product.departureDate).month_string.slice(0, 3)
                    }}
                    -
                    {{ parse_date(product.returnDate).day_number }}
                    {{
                      parse_date(product.returnDate).month_string.slice(0, 3)
                    }}
                    {{ parse_date(product.returnDate).year }}
                  </span>
                </div>
                <div class="pad__info-item">
                  <vb-icon
                    class="pad__info-icon"
                    :name="'moon'"
                    :color="sass('primary')"
                    :size="15"
                  />
                  <span class="pad__info-title">
                    {{ product.nights }} notti
                  </span>
                </div>
                <div class="pad__info-item">
                  <vb-icon
                    class="pad__info-icon"
                    :name="'occupants'"
                    :color="sass('primary')"
                    :size="15"
                  />
                  <span class="pad__info-title">
                    {{ occupancy[0].adults }} adulti
                    <span v-if="occupancy[0].children.length">
                      + {{ occupancy[0].children.length }}
                      {{
                        occupancy[0].children.length > 1 ? "bambini" : "bambino"
                      }}
                    </span>
                  </span>
                </div>
              </div>
            </b-col>
            <b-col
              class="pad__wrap-element pad__wrap-column--second"
              cols="12"
              lg="4"
              xl="3"
            >
              <div class="pad__footer">
                <div class="pad__footer-element">
                  <div class="pad__footer-price">
                    da
                    <vb-icon
                      class="pad__footer-icon"
                      :name="'euro'"
                      :color="
                        sass(
                          availability.is_known &&
                            availability.total <
                              markup(product.price).display_price
                            ? 'secondary'
                            : 'info',
                        )
                      "
                      :size="15"
                    />
                    <span
                      class="pad__footer-value"
                      :class="
                        availability.is_known &&
                        availability.total < markup(product.price).display_price
                          ? 'text-secondary'
                          : ''
                      "
                    >
                      {{ markup(product.price).display_price }}
                    </span>
                  </div>
                  <span class="pad__footer-divide"
                    >(€
                    {{
                      round(
                        divide(
                          markup(product.price).display_price,
                          occupancy[0].adults + occupancy[0].children.length,
                        ),
                        2,
                      )
                    }}/pers.)</span
                  >
                </div>
                <div class="pad__footer-element">
                  <insufficient-credit-alert
                    :availability="availability"
                    :total_price="markup(product.price).display_price"
                    class_name="pad__footer-nocredit"
                    icon_class_name="vb-pad__nocredit-icon ml-1"
                    cta_id="alpitour-pad-insufficient-credit"
                  />
                  <custom-link
                    :before_navigation="
                      () => {
                        update_store({
                          pid: product.pid,
                          departure_date: product.departureDate,
                          days: product.days,
                          solution_id: product.solution_id,
                          room_ref: product.room_ref,
                          keyd: product.keyd,
                        });
                      }
                    "
                    :route_name="'detail'"
                    :css_class="'d-block'"
                  >
                    <template #content>
                      <vb-button
                        class="pad__footer-btn shadow"
                        :vb_options="{
                          text: 'Scopri!',
                          variant: 'info',
                        }"
                      />
                    </template>
                  </custom-link>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { parse_date } from '@utilities/commons'
import { divide, round } from 'mathjs'
import InsufficientCreditAlert from '@alpitour/components/atoms/insufficient-credit-alert.vue'

export default {
  name: "pad",
  components: {
    'insufficient-credit-alert': InsufficientCreditAlert,
  },
  props: {
    product: Object,
    statics: Object,
    occupancy: Array,
    keyds: Object,
    brand: Object,
  },
  created() {
    this.parse_date = parse_date;
  },
  computed: {
    availability() {
      return this.get_availability();
    },
  },
  watch: {},
  data() {
    return {
      price_popover: "Il prezzo che vedi è già comprensivo delle riduzioni o eventuali gratuità previste per i bambini. * I trasferimenti potrebbero non essere sempre inclusi. Per maggiori dettagli, verifica le informazioni presenti nel pacchetto scelto o contatta la nostra assistenza.",
      insurance_popover: "Per i dettagli vedi le Condizioni d'uso"
    };
  },
  methods: {
    divide,
    round,
    contains_numb(str) {
      return /\d/.test(str);
    },
    update_store(params) {
      this.$store.commit("liveat/pid", params.pid);
      this.$store.commit("liveat/days", params.days);
      this.$store.commit("liveat/solution_id", params.solution_id || "");
      this.$store.commit(
        "liveat/room_ref",
        params.room_ref != null ? params.room_ref : "",
      );

      // Build the full detail API payload and store it so detail.vue
      // can read it directly from the store (tazio-fe passthrough pattern).
      const is_only_stay = this.$store.getters["liveat/is_only_stay_package"];
      const detail_params = is_only_stay
        ? {
            ext_id: params.keyd || "",
            checkin: this.$store.state.liveat.checkin_date,
            checkout: this.$store.state.liveat.checkout_date,
            occupancy: [this.$store.state.occupancy[0]],
          }
        : {
            occupancy: this.$store.state.occupancy[0],
            flex_dates: this.$store.state.liveat.flex_dates,
            pid: params.pid,
            departure_date:
              params.departure_date || this.$store.state.liveat.departure_date,
            days: params.days,
          };
      this.$store.commit("liveat/detail_params", detail_params);
    },
  },
  mounted() {},
};
</script>

<style lang="scss">
.pad {
  position: relative;

  @include media-breakpoint-up(lg) {
    height: 204px;
    overflow: hidden;
  }

  & > .row {
    height: 100%;
  }

  &__row {
    width: 100%;
  }

  &__column {
    &--second {
      position: static !important;
    }
  }

  &__image {
    min-height: 300px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    border-radius: $border-radius-lg;
    clip-path: polygon(0% 0%, 100% 0%, 100% 102%, 85% 84%, 0 84%);
    position: relative;
    z-index: 1;

    @include media-breakpoint-up(lg) {
      clip-path: polygon(0 0, 101% 0, 91% 23%, 91% 100%, 0% 101%);
      min-height: 100%;
    }

    // trick angolo smussato
    &-corner {
      width: 30px;
      height: 30px;
      overflow: hidden;
      position: absolute;
      left: 0;
      bottom: 16%;
      z-index: 1;
      transform: scaleX(-1);

      @include media-breakpoint-up(lg) {
        left: auto;
        right: 9%;
        bottom: 0;
        transform: scaleX(1);
      }

      &:before {
        content: "";
        width: 200%;
        height: 200%;
        position: absolute;
        border-radius: 7px;
        bottom: 0;
        right: 0;
        box-shadow: 50px 50px 0 0 $vb-body-bg;
      }
    }
  }

  &__wrap {
    background-color: $white;
    margin-top: -40px;
    padding: $grid-gutter-width/2 $grid-gutter-width * 2/3;
    border-radius: 0 $border-radius-lg $border-radius-lg;
    height: 100%;

    display: flex;
    flex-direction: column;

    @include media-breakpoint-up(lg) {
      flex-direction: row;
      align-items: center;
      margin-top: 0;
      margin-left: -50px;
      padding: $grid-gutter-width * 2/3 $grid-gutter-width * 2
        $grid-gutter-width * 2/3 $grid-gutter-width * 2/3;
    }

    &-column {
      &--first {
        position: static !important;
      }
    }
  }

  &__head {
    &-title {
      @include media-breakpoint-up(lg) {
        display: flex;
        align-items: center;
        position: relative;
      }
    }

    &-star {
      .b-rating {
        .flex-grow-1 {
          flex-grow: unset !important;
        }
      }
      @include media-breakpoint-up(lg) {
        display: flex;
        order: 2;
      }
    }

    &-name {
      font-size: $font-size-base;
      font-weight: $vb-font-weight-semibold;
      margin-bottom: 0;
      margin-top: $grid-gutter-width/6;

      @include media-breakpoint-up(lg) {
        order: 1;
        margin-top: 0;
        margin-right: $grid-gutter-width/2;
      }
    }

    &-brand {
      background-color: $white;
      border-radius: $border-radius-lg * 6;
      width: 110px;
      position: absolute;
      z-index: 2;
      top: 10px;
      right: 10px;
      padding: 7px;

      @include media-breakpoint-up(lg) {
        top: -5px;
        right: 0;
      }
    }

    &-locality {
      color: $gray-500;

      @include media-breakpoint-up(lg) {
        margin-bottom: 10px;
      }
    }

    &-abstract {
      display: none;

      @include media-breakpoint-up(lg) {
        display: -webkit-box;
        font-size: $font-size-sm;

        height: 3lh;

        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* Limita a 3 righe */

        box-orient: vertical;
        line-clamp: 3;

        overflow: hidden;
        text-overflow: ellipsis;

        b {
          font-weight: $vb-font-weight-semibold;
        }
      }
    }
  }

  &__push {
    display: flex;
    align-items: center;

    @include media-breakpoint-up(lg) {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: $dark;
      padding: 0 12px;
      flex-direction: column;
      justify-content: center;
      border-radius: $border-radius-lg;
    }

    &-btn {
      background-color: $vb-body-bg;
      border-radius: 50%;
      padding: 10px;
      margin-right: 10px;

      @include media-breakpoint-up(lg) {
        background-color: transparent;
        border-radius: 0;
        padding: 0 0 15px;
        margin-right: 0;
        margin-bottom: 15px;
        border-bottom: 1px solid $gray-600;
      }

      &:last-child {
        margin-right: 0;

        @include media-breakpoint-up(lg) {
          margin-bottom: 0;
          padding-bottom: 0;
          border-bottom: 0;
        }
      }

      // cambio colore icona desktop
      path {
        @include media-breakpoint-up(lg) {
          fill: $white;
        }
      }
    }
  }

  &__element {
    border-top: 1px solid $gray-200;
    padding-top: 10px;
    margin-top: 10px;

    @include media-breakpoint-up(lg) {
      margin-top: 0;
    }
  }

  &__info {
    display: flex;
    flex-wrap: wrap;
    margin: 10px 0;
    padding: 5px 0;
    border-width: 1px 0;
    border-style: solid;
    border-color: $gray-300;

    @include media-breakpoint-up(lg) {
      padding: 10px 0 0;
      margin-bottom: 0;
      border-bottom: 0;
    }

    &-item {
      display: flex;
      align-items: center;
      flex: 1 1 50%;
      padding-top: 3px;
      padding-bottom: 3px;

      @include media-breakpoint-up(lg) {
        flex: 0 1 auto;
        margin-right: 25px;
        align-items: flex-start;
      }

      &:last-child {
        margin-right: 0;
      }

      &:nth-child(even) {
        padding-left: 10px;

        @include media-breakpoint-up(lg) {
          padding-left: 0;
        }
      }
    }

    &-icon {
      margin-right: 10px;

      @include media-breakpoint-up(lg) {
        margin-right: 5px;
      }
    }

    &-title {
      font-size: $font-size-sm;
      font-weight: $vb-font-weight-semibold;
    }
  }

  &__footer {
    @include media-breakpoint-up(lg) {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      height: 100%;
    }

    &-price {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: normal;
    }

    &-icon {
      margin-left: 5px;
    }

    &-value {
      font-size: $font-size-lg;
      color: $info;
      margin-left: 5px;
      font-weight: $vb-font-weight-semibold;

      @include media-breakpoint-up(lg) {
        font-size: 1.438rem;
      }
    }

    &-divide {
      font-size: $font-size-sm;
      font-weight: $vb-font-weight-semibold;
      text-align: center;
      display: block;
    }

    &-nocredit {
      color: $secondary;
      font-size: $font-size-lg;
      display: flex;
      align-items: baseline;
      justify-content: center;
      font-weight: $vb-font-weight-semibold;
      padding-top: 0.625rem;
      transition: auto;

      @include media-breakpoint-up(lg) {
        font-size: $font-size-sm;
      }
    }

    &-btn {
      margin-top: 20px;
      display: block;
      width: 100%;

      @include media-breakpoint-up(lg) {
        display: inline-block;
        width: 200px;
        margin-top: 10px;
      }
    }
  }
}
</style>
